import React, {useEffect, useState, useRef} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useMessage } from '../../context/message'
import { useAuth } from '../../context/auth'
import { useChat } from '../../context/chat'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Container from '@material-ui/core/Container'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import InputBase from '@material-ui/core/InputBase'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import Popover from '@material-ui/core/Popover'
import Pagination from '@material-ui/lab/Pagination'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AdjustRoundedIcon from '@material-ui/icons/AdjustRounded'
import ReportDialog from '../inputs/ReportDialog'
import InfoDialog from '../display/InfoDialog'
import AlertDialog from '../inputs/AlertDialog'
import InfoIcon from '@material-ui/icons/Info'

const useStyles = makeStyles((theme) => ({
  allChat_container: {
    'borderLeft': '2px solid',
    display: 'inline-block',
    width: '20%',
    height: '750px'
  },
  allChat_list: {
    height: '95%',
  },
  chat_container: {
    display: 'inline-block',
    width: '80%',
    height: '100%',
  },
  chat_messages: {
    height: '95%',
    maxHeight: '665px',
    overflow: 'auto',
    overflowAnchor: 'None',
    'borderBottom': '2px solid',
  },
  page_container: {
    minHeight: '500px',
    minWidth: '1350px'
  },
  received: {
    'width': '85%',
    'border-style': 'solid',
    'border-color': theme.palette.primary.main,
    'border-radius': 40,
    'margin': theme.spacing(2)
  },
  sent: {
    'background-color': theme.palette.primary.main,
    'maxWidth': '85%',
    'minHeight': 40,
    'float': 'right',
    'border-style': 'solid',
    'borderColor': theme.palette.primary.main,
    'border-radius': 40,
    'paddingLeft': 10,
    'paddingRight': 10,
    'paddingTop': 10,
    'paddingBottom': 10,
    'overflow-x':'hidden',
    'overflowAnchor': 'auto',
  },
  divider: {
    'border': '2px solid',
  },
  input: {
    'width': '65%',
    'padding': theme.spacing(2),
  },
  buttonGroup: {
    float: 'right',
    'paddingRight': '5px',
    'paddingTop': '5px'
  },
  title_bar: {
    padding: theme.spacing(1),
    borderBottom: '2px solid',
  },
}));

export default function Chat(params) {
  const classes = useStyles()
  const [chatMessage, setChatMessage] = useState('')
  const {setMessage} = useMessage()
  const {fetchConversations, setFetchConversations} = useChat()
  const { auth } = useAuth();
  const [focus, setFocus] = useState(false)
  const [messages, setMessages] = useState([])
  const [myConversations, setMyConversations] = useState([])
  const [conversation_id, setConversation_id] = useState(params.conversation_id || 0)
  const [conversation_title,  setConversation_title] = useState('Select a conversation')
  const messagesEndRef = useRef(null)
  const[dropdown, setDropdown] = useState(false)
  const[info, setInfo] = useState(false)
  const [leave,setLeave] = useState(false)
  const [closed, setClosed] = useState(false)
  const [report, setReport] = useState(false)
  const [type, setType] = useState('')
  const [id, setId] = useState(0)
  const anchorRef = useRef(null)

  //Pagination
  const [page, setPage] = useState(1)
  const [pageCount, setPageCount] = useState(1)

  const scrollToBottom = () => {
    messagesEndRef.current.scrollIntoView()
  }

  useEffect(() => {
    scrollToBottom()
  }, [focus])

  const openInfo = (event) => {
    setInfo(true)
  }

  const closeInfo = () => {
    setInfo(false)
  }

  const handleMessageChange = (event) => {
    if (chatMessage.concat('\n') !== event.target.value)
      setChatMessage(event.target.value)
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter'){
      writeMessage()
    }
  }

  const openDropdown = () => {
    setDropdown(true)
  }

  const closeDropdown = () => {
    setDropdown(false)
  }

  const reportUser = () => {
    closeDropdown()
    setReport(true)
  }

  const openDialog = () => {
    closeDropdown()
    setLeave(true)
  }

  useEffect(() => {
    if(myConversations){
      myConversations.forEach(function (item, index) {
        if(item.conversation_id === conversation_id) {
          setConversation_title(item.conversation_title)
        }
      })
    }
  }, [conversation_id, myConversations])

  const leaveChat = () => {
    fetch(`/api/message/conversation/${conversation_id}`, {
      method: 'DELETE',
      headers: {
        'x-access-token': sessionStorage.getItem('token'),
      },
    })
    .then((response) => auth(response))
    .then((response) => {
      if (response.message.type === 'success'){
        setChatMessage('')
        setFetchConversations(!fetchConversations)
        setMessage(response.message)
        setLeave(false)
      }
    })
    .catch((error) => {
      setMessage({'type': 'error', 'text': 'Error! Unable to leave chat.'})
      console.error('Error:', error)
    })
  }

  useEffect(() => {
      fetch('/api/message', {
        method: 'GET',
        headers: {
          'x-access-token': sessionStorage.getItem('token')
        }
      })
      .then((response) => auth(response))
      .then((response) => {
        setMyConversations(response.data)
        if(response.data)
          setPageCount(Math.ceil(response.data.length/10))
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchConversations] )

  const handlePageChange = (event, value) => {
    setPage(value)
  }

  const updateRead = (conversation_id) => {
      fetch(`/api/message/conversation/${conversation_id}`, {
        method: 'PUT',
        headers: {
          'x-access-token': sessionStorage.getItem('token'),
        },
      })
      .catch((error) => {
        console.error('Error:', error)
      })
  }

  const open = (conversation) => () => {
    if(conversation.conversation_id !== conversation_id){
      setInfoParams(conversation)
      setConversation_id(conversation.conversation_id)
      updateRead(conversation.conversation_id)
      setFetchConversations(!fetchConversations)
    }
  }

  const setInfoParams = (conversation) => {
    if(conversation.bid_id){
      setType('listing')
      setId(conversation.bid_id)
    } else if (conversation.inquiry_bids_id) {
      setType('inquiry')
      setId(conversation.inquiry_bids_id)
    } else if (conversation.listing_id && !conversation.bid_id) {
      setType('listing_info')
      setId(conversation.listing_id)
    } else if (conversation.inquiry_id && !conversation.inquiry_bids_id) {
      setType('inquiry_info')
      setId(conversation.inquiry_id)
    }
  }

  const writeMessage = () => {
    if (chatMessage !== ''){
      fetch(`/api/message/conversation/${conversation_id}`, {
        method: 'POST',
        headers: {
          'x-access-token': sessionStorage.getItem('token'),
          'Content-Type': 'application/JSON'
        },
        body: JSON.stringify({'message':chatMessage}),
      })
      .then((response) => auth(response))
      .then((response) => {
        setMessages([...messages, {'message':chatMessage, 'author': true}])
        setChatMessage('')
        setFocus(!focus)
        setFetchConversations(!fetchConversations)
      })
      .catch((error) => {
        setMessage({'type': 'error', 'text': 'Error! Unable to write message.'})
        console.error('Error:', error)
      })
    }
  }

  useEffect(()=> {
    if(conversation_id && conversation_id != 0) {
      fetch(`/api/message/conversation/${conversation_id}`,{
          method: 'GET',
          headers: {
            'x-access-token': sessionStorage.getItem('token')
          }
      })
      .then((response) => auth(response))
      .then((response) => {
        if(response.message){
          setMessage(response.message)
        }
        else {
          setMessages(response.data)
          setClosed(response.closed)
          setInfoParams(response.conversation)
          setConversation_title(response.conversation.conversation_title)
          updateRead(conversation_id)
          setFocus(!focus)
        }

      })
      .catch((error) => {
        setMessage({'type': 'error', 'text': 'Error! Conversation does not exist.'})
        console.error('Error: ', error)
      })
    }
  }, [conversation_id, fetchConversations])

  return(
    <div className = {classes.page_container}>
      <AlertDialog
        open = {leave}
        setOpen = {setLeave}
        title = 'Leave Chat'
        content = 'Once you leave the chat you will be unable to send or receive messages.
        However, you will still be able to see previous messages. Are you sure you want to leave the chat?'
        submitText = 'Leave Chat'
        submit = {leaveChat}
      />
      <ReportDialog
          open = {report}
          setOpen = {setReport}
          conversation_id = {conversation_id}
      />
      <InfoDialog
        open = {info}
        onClose = {closeInfo}
        type = {type}
        id = {id}
      />
      {// title bar}
      }
      <div className = {classes.title_bar}>
        <Typography>
          {conversation_title}
        </Typography>
        {conversation_title !== 'Select a conversation' &&
          <IconButton color = 'primary' onClick = {(e) => openInfo(e)}>
            <InfoIcon/>
          </IconButton>
        }
      </div>
      <div className = {classes.chat_container}>
        <Grid>
          <Grid item >
            <Container className = {classes.chat_messages}>
              <List>
                {messages && messages.map((message, key) => (
                  <ListItem key = {key}>
                    <Grid item xs = {12}>
                      <Typography className = {classes.sent} style = {!message['author'] ? {float:'left', 'backgroundColor': '#424242'} : null}>
                        {message['message']}
                      </Typography>
                    </Grid>
                  </ListItem>
                ))}
                {closed &&
                  <ListItem key = 'closed'>
                    <Grid item xs = {12}>
                      <Typography className = {classes.sent} style = {{'backgroundColor': 'red', 'borderColor': 'red'}}>
                        {'Chat has been closed!'}
                      </Typography>
                    </Grid>
                  </ListItem>
                }
                <div ref={messagesEndRef} />
              </List>
            </Container>
            <InputBase
              className = {classes.input}
              placeholder = 'Enter message here'
              value = {chatMessage}
              onChange = {handleMessageChange}
              onKeyDown = {handleKeyDown}
              multiline = {true}
              disabled = {closed}
            />
            <ButtonGroup variant = 'contained' color = 'primary' ref = {anchorRef} className = {classes.buttonGroup}>
              <Button
                onClick = {writeMessage}
              >
                Send
              </Button>
              <Button size = 'small' onClick = {openDropdown}>
                <ArrowDropDownIcon />
              </Button>
            </ButtonGroup>
            <Popover
              open= {dropdown}
              onClose = {closeDropdown}
              anchorEl = {anchorRef.current}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
              <Paper>
                  <MenuItem onClick = {reportUser}>
                    Report User
                  </MenuItem>
                  {!closed &&
                    <MenuItem onClick = {openDialog}>
                      Leave Chat
                    </MenuItem>
                  }
              </Paper>
            </Popover>
          </Grid>
        </Grid>
      </div>
      <div className = {classes.allChat_container}>
          <List className = {classes.allChat_list}>
            {myConversations && myConversations.slice((page-1)*10,(page*10)).map((c) => (
              <ListItem button onClick = {open(c)} key = {c.conversation_id}>
                <ListItemText
                  primary = {
                    <Typography variant = 'body2' style = {c.closed ? {'color': '#d3d3d3'} : null}>
                        {`${c.conversation_id}. ${c.conversation_title}`}
                    </Typography>
                  }
                  secondary = {c.closed ? 'Chat has been closed!' : c.lastMessage}
                  className = {c.last_read !== 0 ? classes.unread : null}
                />
                {(c.last_read !== 0 && c.conversation_id !== conversation_id) &&
                  <AdjustRoundedIcon color = 'primary'/>
                }
              </ListItem>
            ))}
          </List>
          <Pagination count={pageCount} size = 'small' page={page} onChange={handlePageChange}/>
      </div>
    </div>

  )
}
